import axios from "axios";
import { IBreedingStud, IBreedingStudPDTO } from "../models/breedingStud";
import { API_CENTRE } from "./config";
import { apiCallWithAuth } from "../helper/apiManager";

export default class BreedingStudService {
  //Get BreedingStud by Id
  static async getBreedingStudById(id: number) {
    try {
      const { data } = await apiCallWithAuth(
        API_CENTRE +
          "/api/v1/breedingstuds/search?Include=*&Id=" +
          id,
      );
      return {
        err: false,
        data: data,
      };
    } catch (err) {
      return {
        err: true,
        data: err,
      };
    }
  }

  //Get BreedingStuds with filter
  static async getBreedingStud(
    page: number,
    pageSize: number,
    indicative: string = "",
  ) {
    try {
      const { data } = await apiCallWithAuth(
        API_CENTRE +
          "/api/v1/breedingstuds/search?Include=*&PageNumber=" +
          page +
          "&PageSize=" +
          pageSize +
          "&GlobalSearch=" +
          indicative +
          "",
      );

      return {
        err: false,
        data: data,
      };
    } catch (err: any) {
      return {
        err: true,
        data: [],
      };
    }
  }

  //Create BreedingStud
  static async createBreedingStud(breedingStud: IBreedingStudPDTO) {
    try {
      const { data } = await apiCallWithAuth(
        API_CENTRE + "/api/v1/breedingstuds",
        "post",
        breedingStud,
      );

      return {
        err: false,
        data: data,
      };
    } catch (err: any) {
      return {
        err: true,
        data: err,
      };
    }
  }

  //Update BreedingStud
  static async updateBreedingStud(breedingStud: IBreedingStudPDTO) {
    try {
      const { data } = await apiCallWithAuth(
        API_CENTRE + "/api/v1/breedingstuds?Id=" + breedingStud.id,
        "put",
        breedingStud,
      );

      return {
        err: false,
        data: data,
      };
    } catch (err) {
      return {
        err: true,
        data: err,
      };
    }
  }

  static async editBreedingStudActiveStatus(breedingStudId: number, isActive: boolean) {
    try {
        const { data } = await apiCallWithAuth(API_CENTRE + `/api/v1/breedingstuds/${breedingStudId}/status/${isActive}`, 'post')

        return {
            'error': false,
            'data': data
        }
    }
    catch (err) {
        return {
            'error': true,
            'data': err
        }
    }
}
}
